<template>
    <span
        class="wishlist-modal-icon small-icons heart-icon"
        @click="openModalMethod()"
        :title="title"
        :class="[wishlistIcon ? 'active' : '']"
    ></span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        title: {
            default: 'Empty',
            type: String,
        },
        anchorHoverBehavior: {
            default: 'add',
        },
        modalType: {
            default: 'Empty',
            type: String,
        },
        modalId: {
            default: 0,
        },
        modalCloseButton: {
            default: false,
            type: Boolean,
        },
        modalContent: {
            default: 'false',
            type: String,
        },
        inUserWishlist: {
            default: false,
        },
    },
    data() {
        return {
            openModal: false,
            wishlistIcon: false,
        };
    },
    mounted() {
        this.wishlistIcon = this.inUserWishlist;
        this.$store.commit('store-modals/SET_TOOGLE_MODAL', this.openModal);
    },
    methods: {
        openModalMethod() {
            this.$store.commit('store-modals/SET_TOOGLE_MODAL', !this.openModal);
            this.$store.commit('store-modals/SET_MODAL_TYPE', this.modalType);
            this.$store.commit('store-modals/SET_MODAL_ID', this.modalId);
            this.$store.commit('store-modals/SET_MODAL_CLOSE_BUTTON', this.modalCloseButton);
            this.$store.commit('store-modals/SET_MODAL_CONTENT', this.modalContent);
        },
    },
    computed: {
        ...mapGetters({
            inWishlist: 'store-modals/wishlistIcon',
        }),
    },
    watch: {
        inWishlist(newValue, oldValue) {
            if (newValue > 0 && oldValue === 0) {
                this.wishlistIcon = true;
            }

            if (newValue == 0) {
                this.wishlistIcon = false;
            }
        },
    },
};
</script>